/**
 * TripCountdownSection — quick "N days until" stat card for the hub.
 * Reuses the same maths as NextAdventureCard but presented compactly.
 */
import { useEffect, useState } from "react";
import { Plane } from "lucide-react";

export default function TripCountdownSection({ trip }) {
  const start = trip.start_date || trip.target_date;
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);
  if (!start) return null;

  const startMs = new Date(start).getTime();
  const days = Math.ceil((startMs - now) / 86400000);
  let label;
  if (days > 1) label = `${days} days to go`;
  else if (days === 1) label = "1 day to go";
  else if (days === 0) label = "✈️ Today's the day";
  else if (trip.end_date && new Date(trip.end_date).getTime() >= now) label = "🌍 Enjoy your adventure";
  else label = "Welcome home";

  return (
    <div className="rounded-2xl bg-card border border-border p-5 flex items-center gap-4" data-testid="trip-countdown-section">
      <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
        <Plane className="w-5 h-5 text-primary" />
      </div>
      <div className="flex-1">
        <p className="text-xs uppercase tracking-widest text-muted-foreground">Countdown</p>
        <p className="font-serif text-2xl text-foreground">{label}</p>
      </div>
    </div>
  );
}
